// extracted by mini-css-extract-plugin
export default {"company":"Company_company__gWGnL","title":"Company_title__-EdeM","body":"Company_body__mfbif","item":"Company_item__iJEOd"};